import { request } from '@umijs/max';

// 获取操作员分页列表
export async function getShopOperatorPage(params: API.PageParams) {
  return request('/api/shop/shopOperator/page', {
    method: 'POST',
    data: params,
  });
}

// 获取操作员详情
export async function getShopOperatorInfo(params: { id: number }) {
  return request('/api/shop/shopOperator/info', {
    method: 'POST',
    data: params,
  });
}

// 新增操作员
export async function addShopOperator(params: any) {
  return request('/api/shop/shopOperator/add', {
    method: 'POST',
    data: params,
  });
}

// 编辑操作员
export async function editShopOperator(params: any) {
  return request('/api/shop/shopOperator/edit', {
    method: 'POST',
    data: params,
  });
}

// 删除操作员
export async function removeShopOperator(params: { id: number[] }) {
  return request('/api/shop/shopOperator/remove', {
    method: 'POST',
    data: params,
  });
}
